// §29.8 / §9.1 — Rivet as an in-process app.
//
// Manifest only (D-247): the engine, the view, the CSS and the sprite sheet all live behind the
// thunk, so a desktop that never opens this window never downloads any of it (D-199, D-367).
//
// Not a factory. Rivet is single-player — §30.1's multiplayer allowlist does not name it — so it
// needs no `PlayShellAccess` and taking one would imply a session it never opens.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createRivetApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'rivet',
      name: 'Rivet',
      // §29.1 (D-379) — the glyph is fixed by the roster, not chosen here.
      icon: { glyph: 'hammer', hue: 32 },
      keywords: ['climb', 'ladders', 'crane', 'girders', 'platform', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed-aspect letterboxed canvas (D-229, D-374). Here the fixed fit is what keeps the
      // boards honest: a board is authored against a 16 × 15 grid, and a stretched one would make
      // a three-tile fall look like a different distance from window to window.
      window: { width: 720, height: 720, minWidth: 460, minHeight: 460, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Rivet'),
  });
}
